import { AreaField, Card } from "../Field";

const sections = [
  { key: "steta", title: "Evidencija štete u školi i oko škole", badge: "Šteta", hint: "Oštećenja inventara, zgrade, dvorišta i opreme" },
  { key: "nasilje", title: "Evidencija nasilnog ili neprimjerenog ponašanja", badge: "Ponašanje", hint: "Sukobi, vršnjačko nasilje, neprimjereno ponašanje" },
  { key: "otudjenje", title: "Evidencija otuđenja stvari u školi", badge: "Otuđenja", hint: "Nestale ili otuđene stvari učenika i škole" },
  { key: "nepoznateOsobe", title: "Evidencija nepoznatih osoba u školi", badge: "Sigurnost", hint: "Neovlaštene ili nepoznate osobe u prostoru škole" },
];

export default function ZapazanjaTab({ record, update }) {
  const z = record.zapazanja;
  return (
    <div className="grid gap-5 lg:grid-cols-2">
      {sections.map((s) => (
        <Card key={s.key} title={s.title} subtitle={s.hint} badge={s.badge}>
          <AreaField
            label="Zapažanja"
            value={z[s.key]}
            onChange={(v) => update({ zapazanja: { ...z, [s.key]: v } })}
            testId={`form-zapazanja-${s.key}-input`}
            rows={5}
            placeholder="Ako nije bilo događaja, ostavite prazno"
          />
        </Card>
      ))}
    </div>
  );
}
